// extracted by mini-css-extract-plugin
export default {"button_floating":"ButtonFloating_button_floating__QsxT4","button_floating_mobile":"ButtonFloating_button_floating_mobile__ZN7vR"};